import React from 'react';
import { Button, Modal, Form, Spinner, Table, Row, Col, Badge } from 'react-bootstrap';

const ServicosTab = ({
  servicos,
  showModal,
  handleCloseModal,
  handleOpenModal,
  handleEditClick,
  handleToggleStatus,
  isLoading,
  formData,
  handleChange,
  handleSubmit,
  tiposMateriais,
  materiais,
  selectedMaterialsData,
  handleMaterialChange,
  handleQuantidadeChange,
  custoMaterialCalculado,
  currentServico,
  mostrarInativos,
  setMostrarInativos
}) => {
  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal} dialogClassName="modal-novo-servico-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{currentServico ? 'Editar Serviço' : 'Criar Novo Serviço'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="nomeModal">
              <Form.Label>Nome</Form.Label>
              <Form.Control type="text" name="nome" value={formData.nome} onChange={handleChange} required />
            </Form.Group>

            <Form.Group controlId="descricaoModal">
              <Form.Label>Descrição</Form.Label>
              <Form.Control type="text" name="descricao" value={formData.descricao} onChange={handleChange} />
            </Form.Group>

            <Form.Group controlId="valorModal">
              <Form.Label>Valor</Form.Label>
              <Form.Control type="number" step="0.01" name="valor" value={formData.valor} onChange={handleChange} required />
            </Form.Group>

            <Form.Group controlId="percentualComissaoModal">
              <Form.Label>Percentual de Comissão (%)</Form.Label>
              <Form.Control type="number" step="0.01" name="percentual_comissao" value={formData.percentual_comissao || ''} onChange={handleChange} />
            </Form.Group>

            <Form.Group controlId="numeroSessoesModal">
              <Form.Label>Número de Sessões</Form.Label>
              <Form.Control type="number" step="1" min="1" name="numero_sessoes" value={formData.numero_sessoes || 1} onChange={handleChange} required />
              <Form.Text className="text-muted">
                Para pacotes, insira o total de sessões. Para serviços únicos, deixe o valor como 1.
              </Form.Text>
            </Form.Group>

            <Form.Group controlId="custoMaterialModal">
              <Form.Label>Custo Material</Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                name="custo_material"
                value={custoMaterialCalculado}
                readOnly // O custo é calculado
              />
            </Form.Group>

            <Form.Group controlId="tiposMateriaisModal">
              <Form.Label>Tipos de Materiais:</Form.Label>
              <Form.Control as="select" multiple name="tipos_materiais" value={formData.tipos_materiais} onChange={handleChange}>
                {tiposMateriais.map((tipoMaterial) => (
                  <option key={tipoMaterial.id} value={tipoMaterial.id}>{tipoMaterial.nome}</option>
                ))}
              </Form.Control>
            </Form.Group>

            {formData.tipos_materiais?.length > 0 && (
              <Form.Group controlId="materiaisModal">
                <Form.Label>Materiais:</Form.Label>
                {materiais
                  .filter(material => formData.tipos_materiais.includes(material.materiais_tipos_id))
                  .map(material => (
                    <div key={material.id} className="mb-2">
                      <Form.Check
                        type="checkbox"
                        label={`${material.nome} (${material.fabricante || 'N/A'}) - Lote/Entrada de ${material.quantidade_adquirida} ${material.tipo_material?.unidade_medida || 'unid.'} (Estoque Total: ${material.tipo_material?.estoque?.quantidade_em_estoque || 0})`}
                        checked={selectedMaterialsData.some(item => item.id === material.id)}
                        onChange={(e) => handleMaterialChange(material.id, e.target.checked)}
                      />
                      {selectedMaterialsData.some(item => item.id === material.id) && (
                        <Row className="mt-1 gx-2">
                          <Col xs={8} sm={9}>
                            <Form.Control
                              type="number"
                              size="sm"
                              name="quantidade_utilizada"
                              placeholder="Qtd. utilizada"
                              min="0"
                              max={Math.min(material.quantidade_adquirida, material.tipo_material?.estoque?.quantidade_em_estoque || 0)}
                              value={selectedMaterialsData.find(item => item.id === material.id)?.quantidade_utilizada || 0}
                              onChange={(e) => handleQuantidadeChange(material.id, parseInt(e.target.value, 10))}
                            />
                          </Col>
                           <Col xs={4} sm={3} className="d-flex align-items-center">
                             <small className="text-muted">{material.tipo_material?.unidade_medida || 'N/A'}</small>
                           </Col>
                        </Row>
                      )}
                    </div>
                  ))
                }
              </Form.Group>
            )}

            <Button variant="primary" type="submit" disabled={isLoading} className="mt-3">
              {isLoading ? <Spinner animation="border" size="sm" /> : 'Salvar'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="mt-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2>Serviços Cadastrados</h2>
            <Form.Check 
              type="switch"
              id="mostrar-inativos-switch"
              label="Mostrar Inativos"
              checked={mostrarInativos}
              onChange={(e) => setMostrarInativos(e.target.checked)}
            />
          </div>

          {isLoading ? (
            <div className="text-center mt-3">
              <Spinner animation="border" />
              <p>Carregando serviços...</p>
            </div>
          ) : servicos.length > 0 ? (
          <Table striped bordered hover responsive="sm">
            <thead>
              <tr>
                <th>Nome</th>
                <th className="d-none d-md-table-cell">Descrição</th> {/* Oculta em telas menores que md */}
                <th>Valor (R$)</th>
                <th>Comissão (%)</th>
                <th>Sessões</th>
                <th>Custo Material (R$)</th>
                <th>Materiais Vinculados</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {servicos.map((servico) => (
                <tr key={servico.id} className={!servico.ativo ? 'table-secondary text-muted' : ''}>
                  <td>
                    {servico.nome}
                    {!servico.ativo && <Badge bg="danger" className="ms-2">Inativo</Badge>}
                  </td>
                  <td className="d-none d-md-table-cell">{servico.descricao}</td> {/* Oculta em telas menores que md */}
                  <td>{parseFloat(servico.valor).toFixed(2)}</td>
                  <td>{servico.percentual_comissao ? `${parseFloat(servico.percentual_comissao).toFixed(2)}%` : 'N/A'}</td>
                  <td>
                    {servico.numero_sessoes > 1 
                      ? `${servico.numero_sessoes} sessões` 
                      : 'Única'}
                  </td>
                  <td>{parseFloat(servico.custo_material).toFixed(2)}</td>
                  <td>
                    {servico.materiais && servico.materiais.length > 0 ? (
                      <ul>
                        {servico.materiais.map((material) => (
                          <li key={material.id}>{material.nome} ({material.pivot.quantidade_utilizada} )</li>
                        ))}
                      </ul>
                    ) : ('Nenhum')}
                  </td>
                  <td style={{ minWidth: '130px' }}>
                    <div className="d-flex align-items-center">
                      <Button variant="outline-primary" size="sm" onClick={() => handleEditClick(servico)} className="me-3">Editar</Button>
                      <Form.Check 
                        type="switch"
                        id={`servico-ativo-${servico.id}`}
                        checked={!!servico.ativo}
                        onChange={() => handleToggleStatus(servico.id)}
                        title={servico.ativo ? 'Serviço Ativo' : 'Serviço Inativo'}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
      ) : (
            <p className="mt-3">Nenhum serviço {mostrarInativos ? 'inativo' : 'ativo'} encontrado.</p>
      )}
      </div>
      <Button variant="primary" onClick={handleOpenModal} className="mt-3">
        Novo Serviço
      </Button>
    </>
  );
};

export default ServicosTab;